import { useState, useEffect } from 'react';

export function useLocalStorage<T>( key: string, initial: T ) {
  const [ state, setState ] = useState<T>( () => {
    try {
      if ( typeof window === 'undefined' ) {return initial;}
      const raw = window.localStorage.getItem( key );
      return raw ? ( JSON.parse( raw ) as T ) : initial;
    } catch {
      return initial;
    }
  } );

  useEffect( () => {
    if ( typeof window === 'undefined' ) {return;}
    window.localStorage.setItem( key, JSON.stringify( state ) );
  }, [ key, state ] );

  return [ state, setState ] as const;
}
